import { render, staticRenderFns } from "./formParams.vue?vue&type=template&id=63d96873&scoped=true&"
import script from "./formParams.vue?vue&type=script&lang=js&"
export * from "./formParams.vue?vue&type=script&lang=js&"
import style0 from "./formParams.vue?vue&type=style&index=0&id=63d96873&lang=scss&scoped=true&"
import style1 from "./formParams.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63d96873",
  null
  
)

export default component.exports